import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDetectEscapeKeyPressed, useInternalRef } from '../../../../utils';
export var useHeaderNavigationMenu = function useHeaderNavigationMenu(_ref, ref) {
  var isMenuExpanded = _ref.isMenuExpanded,
      defaultExpanded = _ref.defaultExpanded;
  var internalRef = useRef(null);

  var _useState = useState(defaultExpanded || isMenuExpanded),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  useInternalRef(ref, internalRef);
  var handleMenuClick = useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    setIsExpanded(!isExpanded);
  }, [isExpanded]);
  useEffect(function () {
    var _a;

    (_a = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('click', handleMenuClick);
    return function () {
      var _a;

      (_a = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', handleMenuClick);
    };
  }, [internalRef, isExpanded, handleMenuClick]);
  useDetectEscapeKeyPressed(internalRef, setIsExpanded, isExpanded);
  return {
    internalRef: internalRef,
    isExpanded: isExpanded,
    setIsExpanded: setIsExpanded
  };
};